import styled from 'styled-components';

const ColumnComponent = styled.div`
  display: flex;
  flex-direction: column;
  transition: background-color 250ms;

  box-sizing: border-box;
  flex: 0 0 272px;
  height: 100%;
  min-width: 272px;
  width: 272px;
  max-width: 272px;
  position: relative;

  border-width: 2px;
  border-style: dashed;
  border-color: transparent;

  background-color: var(--coolest-gray-20);
`;
const ColumnWrapper = styled.div`
  box-sizing: border-box;
  flex: 0 0 284px;
  height: 100%;
  min-width: 284px;
  width: 284px;
  max-width: 284px;
  position: relative;

  padding-left: var(--spacing-04);
  padding-right: var(--spacing-04);

  background-color: var(--coolest-gray-20);
`;
const Columns = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;

  ${ColumnWrapper} {
    &:not(:last-child) {
      margin-right: var(--layout-01);
    }
  }
`;

const Header = styled.div`
  align-items: center;
  display: flex;
  position: relative;
`;

const ScrollableContainerComponent = styled.div`
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
  min-height: 0;
  margin-top: var(--spacing-03);
  position: relative;
`;

const Scrollable = styled.div`
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
  margin: -2px -12px 0;
  overflow-x: hidden;
  padding: 2px 12px 0;

  min-height: 1px;
  overflow-y: auto;

  scroll-padding-bottom: 24px;
  scroll-padding-top: 24px;
`;

const ListComponent = styled.div`
  flex: 1 0 100%;
  position: relative;
  width: 256px;
`;

const SortableListItemContainerComponent = styled.div`
  display: flex;
  height: 100%;
  width: 100%;

  flex-direction: column;
`;

const Item = styled.div`
  height: 256px;
  width: 120px;
`;

const ItemContainerComp = styled.div`
  flex: 0 0 auto;
  padding-bottom: var(--spacing-03);
`;

type ItemContainerComposition = typeof ItemContainerComp & {
  Item: typeof Item;
};

const ItemContainer: ItemContainerComposition = ItemContainerComp as any;

ItemContainer.Item = Item;

type SortableListItemContainerComposition =
  typeof SortableListItemContainerComponent & {
    ItemContainer: ItemContainerComposition;
  };

const SortableListItemContainer: SortableListItemContainerComposition =
  SortableListItemContainerComponent as any;

SortableListItemContainer.ItemContainer = ItemContainer;

type ListComposition = typeof ListComponent & {
  Container: SortableListItemContainerComposition;
};

const List: ListComposition = ListComponent as any;

List.Container = SortableListItemContainer;

type ScrollableContainerComposition = typeof ScrollableContainerComponent & {
  Scrollable: typeof Scrollable;
  List: typeof List;
};

const ScrollableContainer: ScrollableContainerComposition =
  ScrollableContainerComponent as any;

ScrollableContainer.Scrollable = Scrollable;
ScrollableContainer.List = List;

type ColumnComposition = typeof ColumnComponent & {
  Header: typeof Header;
  Container: typeof ScrollableContainer;
};

const Column: ColumnComposition = ColumnComponent as any;

Column.Header = Header;
Column.Container = ScrollableContainer;

type Board = typeof BoardComponent & {
  Body: typeof Body;
};
const BodyComponent = styled.div`
  height: 100%;
`;

type BodyComposition = typeof BodyComponent & {
  Columns: typeof Columns;
  Column: typeof Column;
  ColumnWrapper: typeof ColumnWrapper;
};

export const Body: BodyComposition = BodyComponent as any;
Body.Columns = Columns;
Body.Column = Column;
Body.ColumnWrapper = ColumnWrapper;
const BoardComponent = styled.div``;

const Board: Board = BoardComponent as any;

Board.Body = Body;

export { Board };
